import { useState, useRef, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { DropdownContainer, DropdownButton, DropdownMenu } from './styles';

export const MobileDropdown = ({ items, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <DropdownContainer ref={dropdownRef}>
      <DropdownButton onClick={() => setIsOpen(!isOpen)}>
        ☰ Menu
      </DropdownButton>
      {isOpen && (
        <DropdownMenu>
          {items.map((item, index) => (
            <NavLink 
              key={index} 
              to={item.to} 
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                isActive || item.activeMatch?.some((path) => location.pathname.startsWith(path))
                  ? 'active'
                  : undefined
              }
            >
              {item.text}
            </NavLink>
          ))}
        </DropdownMenu>
      )}
    </DropdownContainer>
  );
};